import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import { LoyaltyProfile, Reward, TokenizedPaymentCard, CustomerProfile } from '@/models';
import { Promotion } from '@/models';
import { formatGiftCardNumberWithSpaces, getVibesSmartLinkBaseUrl, formatExpirationDate } from '@/helpers';

@Component({
  name: 'CmgLoyaltyRewardCard',
})
export default class CmgLoyaltyRewardCard extends Vue {
  @Prop({ required: false, default: null, type: Object })
  member?: LoyaltyProfile;

  @Prop({ required: false, default: null, type: Object })
  promotion?: Promotion;

  @Prop({ required: false, default: null, type: Object })
  bagOffer?: Reward;

  @Prop({ required: false, default: null, type: Object })
  giftCard?: TokenizedPaymentCard;

  @Prop({ required: false, default: 0, type: Number })
  balance?: number;

  get isOniPhone() {
    return this.$services.utils.iOSDevice()
  }
  get isOnAndroid(): boolean {
    return this.$services.utils.androidDevice()
  }
  
  get addToWalletImageUrl(): string {
    if (this.isOniPhone) {
      return this.$appStore.state.cms.images.buttons.addToAppleWallet.default;
    }
    if (this.isOnAndroid) {
      return this.$appStore.state.cms.images.buttons.googlePaySaveToPhone.default;
    }
    return '';
  }

  get isCustomerStudent(): boolean {
    return this.$appStore.getters.isActiveStudent;
  }

  get studentCheckImg(): string {
      return this.$appStore.state.cms.images.icons.studentUCheck.default;
  }

  onClickRedeem(event: any) {
    const onRedeemModal = () => {
      this.$emit("reward-redeemed");
      this.$services.ui.setBagRewardsToastVisible(true);
    };

    this.$services.ui.setModalVisibility('rewardDetail', true, { 
      reward: this.bagOffer as Reward,
      onRedeem: onRedeemModal
    });
    this.$services.ui.firstFocus();
  }

  formatGiftCardNumber(giftCardNumber: string) {
    return formatGiftCardNumberWithSpaces(giftCardNumber);
  }

  formatPrice(price: number | null): string {
    return this.$services.utils.formatPrice(price);
  }

  formatExpirationDate(expirationDate: string): string {
    return formatExpirationDate(expirationDate, this.$appStore.state.ui.countryProfile.countryCode);
  }

  onClickAddToWallet(): void {
    const { profile } = this.$store.state.customer;
    const loyaltyId = profile && this.$services.loyalty.getLoyaltyProfile(profile)?.memberId;

    if(loyaltyId) {
      this.$services.loyalty.getVibesSmartLink(loyaltyId)
        .then((data) => {
          const index = data.indexOf('=');
          const [key,value] = [data.substring(0, index), data.substring(index + 1)]

          const params = new URLSearchParams();
          params.set(key, value); 
          
          const url = `${getVibesSmartLinkBaseUrl()}?${params}`;

          window.open(url, '_self');
        });    
    }
  }

  get customer(): CustomerProfile | null {
      const profile = this.$appStore.state.customer.profile;
      return profile && !profile.isGuest ? profile : null;
  }

  get studentFirstName(): string {
      return this.customer?.displayFirstName || this.customer?.firstName || '';
  }

  get studentLastName(): string {
      return this.customer?.displayLastName || this.customer?.lastName || '';
  }

  get isNameLong(): boolean {
    return this.studentFirstName.length > 12 || this.studentLastName.length > 12;
  }
}
